"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../../runtime/dom");
var AlertWrapper = /** @class */ (function (_super) {
    __extends(AlertWrapper, _super);
    function AlertWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns the container node of the component.
     */
    AlertWrapper.prototype.findRootElement = function () {
        return this.find('.awsui-alert');
    };
    AlertWrapper.prototype.findDismissButton = function () {
        return this.find('.awsui-alert-dismiss button');
    };
    AlertWrapper.prototype.findHeader = function () {
        return this.find('.awsui-alert-header');
    };
    AlertWrapper.prototype.findContent = function () {
        return this.find('[awsui-alert-region="content"]');
    };
    AlertWrapper.prototype.findActionButton = function () {
        return this.find('.awsui-alert-action-button');
    };
    return AlertWrapper;
}(dom_1.ComponentWrapper));
exports.default = AlertWrapper;
//# sourceMappingURL=awsui-alert.js.map